import { render, staticRenderFns } from "./bonusList.vue?vue&type=template&id=f35adc9e&"
import script from "./bonusList.vue?vue&type=script&lang=js&"
export * from "./bonusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports